import { render, staticRenderFns } from "./EditResellerPage.vue?vue&type=template&id=532cd258"
import script from "./EditResellerPage.vue?vue&type=script&lang=js"
export * from "./EditResellerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports